<template>
  <div id="app">
    <!-- <router-view/> -->
    <keep-alive>
        <router-view></router-view>
      </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  /* height: 100%; */
}
#app>div {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/App.vue